import DOMPurify from "dompurify";

// Renders sanitized rich-text HTML (from the TipTap editor) on public pages.
export default function RichContent({ html, className = "" }) {
  const clean = DOMPurify.sanitize(html || "", {
    ADD_TAGS: ["iframe", "video", "source"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "target", "controls", "loading", "class", "data-align", "rel"],
  });
  return (
    <div className={`rich-content prose max-w-none ${className}`} data-testid="rich-content" dangerouslySetInnerHTML={{ __html: clean }} />
  );
}
